import React, { Component } from 'react';
import { Modal, Tag, Card, Col, Row, Divider, Button } from 'antd';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';

import categoryListImport from '../categoryList';
import LightboxThumb from './LightboxThumb';

const categoryList = new Map(categoryListImport);

class TextureModal extends Component {
  state = { thumbIndex: 0, images: [this.props.texture] };

  constructor(props) {
    super(props);
    this.thumbnailContainer = React.createRef();
    this.modal = React.createRef();
  }

  componentDidMount() {
    this.calculate();
    this.modal.current.focus();
  }

  componentDidUpdate() {
    this.checkOverFlow();
  }

  checkOverFlow = () => {
    if (
      this.thumbnailContainer.offsetWidth < this.thumbnailContainer.scrollWidth &&
      !this.state.showMore
    ) {
      this.setState({ showMore: true });
    }
  };

  handleKeyDown = e => {
    const { thumbIndex, images } = this.state;
    // arrow up/down button should select next/previous list element
    let delta = 0;
    if (e.keyCode === 37) {
      delta = -1;
      if (thumbIndex === 0) delta = images.length - 1;
    } else if (e.keyCode === 39) {
      delta = 1;
      if (thumbIndex === images.length - 1) delta = -images.length + 1;
    }
    this.setState(prevState => ({
      thumbIndex: prevState.thumbIndex + delta,
    }));
  };

  calculate = () => {
    const { texture } = this.props;
    const { children } = texture;
    const images = children ? [texture, ...children] : [texture];

    // if (offset !== 0) offset += 700;
    this.setState({ images });
  };

  render() {
    const { texture, modal, onClose } = this.props;
    const { tags, categories } = texture;
    const { images, thumbIndex } = this.state;
    const widths = images.map(({ width }) => parseInt(width * 0.666, 10));
    widths.length = thumbIndex === 0 ? 0 : thumbIndex;
    const offset = -widths.reduce((a, b) => a + b, 0);
    return (
      <div ref={this.modal} tabIndex="0" onKeyDown={this.handleKeyDown}>
        <Modal
          style={{ top: '0', overflow: 'hidden', padding: 0 }}
          bodyStyle={{ height: '100vh' }}
          width="100%"
          height="100%"
          closeIcon
          footer={null}
          visible={modal}
          onCancel={onClose}
        >
          <div
            style={{
              marginTop: '3em',
              marginBottom: '3em',
            }}
          >
            <Row
              style={{
                height: images.length === 1 ? '90vh' : '60vh',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ textAlign: 'center', width: '100%' }}>
                <img
                  style={{ maxWidth: '100%', maxHeight: '100%' }}
                  alt={images[thumbIndex].key}
                  src={`https://d1wumrtbuo797i.cloudfront.net/thumb-large-${
                    images[thumbIndex].key
                  }`}
                />
              </div>
              <div style={{ height: '100%' }}>
                <Card style={{ background: '#151515 ', flex: 1, height: '100%' }}>
                  <h3> {categories.length > 1 ? 'Categories' : 'Category'} </h3>

                  <Divider />
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {categories.map(i => {
                      const { children, category, id, parent_id } = categoryList.get(i);
                      let link = `/textures/${category}/${id}`;
                      if (children) {
                        link = `/category/${category}/${id}`;
                      }
                      let prefix;
                      if (parent_id) {
                        const {
                          children: pChildren,
                          category: pCategory,
                          id: pId,
                        } = categoryList.get(parent_id);
                        let parent_link = `/textures/${pCategory}/${pId}`;
                        if (pChildren) {
                          parent_link = `/category/${pCategory}/${pId}`;
                        }
                        prefix = <Link to={parent_link}>{pCategory}</Link>;
                      }
                      return (
                        <span style={{ textColor: '#d2d2d2' }} key={category}>
                          {prefix}
                          {prefix && '>'}
                          <Link to={link}>{category}</Link>
                        </span>
                      );
                    })}
                  </div>
                  <br />
                  <h3>Tags </h3>
                  <Divider />
                  {tags && tags.map(tag => <Tag key={tag}>{tag}</Tag>)}
                  <Divider />
                  <Button
                    onClick={() => downloadFile(images[thumbIndex].key, images[thumbIndex].id)}
                    type="primary "
                    size="large"
                  >
                    <FontAwesomeIcon
                      className="tools"
                      style={{
                        cursor: 'pointer',
                        fontSize: '1em',
                        filter: 'drop-shadow(1px 1px 2px rgba(0,0,0,1))',
                        margin: 2,
                      }}
                      icon="download"
                      onClick={() => downloadFile(images[thumbIndex].key, images[thumbIndex].id)}
                    />
                    Download File
                  </Button>
                  <Divider />
                  {/* <a href="https://www.sharetextures.com" rel="noopener noreferrer" target="_blank">
                    <img
                      alt="share textures ad"
                      style={{ maxWidth: '100%' }}
                      src="https://d1wumrtbuo797i.cloudfront.net/shareTexturesAd1.jpg"
                    />
                  </a> */}
                </Card>
              </div>
            </Row>
            {images.length > 1 && (
              <div
                ref={this.thumbnailContainer}
                style={{
                  background: 'black',
                  marginTop: '2em',
                  overflow: 'hidden',
                  position: 'absolute',
                  bottom: '1em',
                  marginLeft: 'auto',
                  width: '100%',
                  padding: '1em',
                  left: 0,
                }}
              >
                <div
                  style={{
                    padding: '0 2% 0 2%',
                    zIndex: 1,
                    display: 'flex',
                    marginLeft: '40%',
                    transform: `translateX(${offset}px)`,
                    WebkitTransitionDuration: '0.5s',
                    transitionDuration: '0.5s',
                    WebkitTransitionProperty: 'transform',
                    transitionProperty: 'transform',
                    transitionTimingFunction: 'ease-in-out',
                  }}
                >
                  {images.map(({ key }, index) => (
                    <LightboxThumb
                      selected={thumbIndex === index}
                      onClick={() => this.setState({ thumbIndex: index })}
                      src={`https://d1wumrtbuo797i.cloudfront.net/thumb-${key}`}
                      key={key}
                      alt={key}
                    />
                  ))}
                  {!this.state.showMore && (
                    <div style={{ color: 'red', height: '100%', width: '100px' }} />
                  )}
                </div>
              </div>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}
export default TextureModal;

function downloadFile(filename, id) {
  const downloadUrl = 'https://texture-ninja.nyc3.cdn.digitaloceanspaces.com/';
  const url = downloadUrl + filename;
  const tempLink = document.createElement('a');
  tempLink.style.display = 'none';
  tempLink.href = url;
  tempLink.setAttribute('download', filename);

  // Safari thinks _blank anchor are pop ups. We only want to set _blank
  // target if the browser does not support the HTML5 download attribute.
  // This allows you to download files in desktop safari if pop up blocking
  // is enabled.
  if (typeof tempLink.download === 'undefined') {
    tempLink.setAttribute('target', '_blank');
  }

  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
  // window.URL.revokeObjectURL(blobURL);
  axios.post('/api/download_image', { id });
}



// WEBPACK FOOTER //
// ./src/components/textureModal/TextureModal.js